import type { HugeiconsProps } from '@hugeicons/react-native';
import {
  EarthIcon as EarthSolidIcon,
  Location01Icon as Location01SolidIcon,
  Search02Icon as Search02SolidIcon,
  StarIcon as StarSolidIcon,
} from '@hugeicons-pro/core-solid-rounded';
import {
  EarthIcon,
  Location01Icon,
  Search02Icon,
  StarIcon,
} from '@hugeicons-pro/core-stroke-rounded';
import type { TFunction } from 'i18next';

import { feedTypes, type FeedType } from '~/constants/lists';

export interface IFeedListItem {
  value: FeedType;
  label: string;
  icon: HugeiconsProps['icon'];
  solidIcon: HugeiconsProps['icon'];
  href: string;
  separatorBefore?: boolean;
  sectionTitleBefore?: string;
}

const feedIcons: Record<FeedType, [HugeiconsProps['icon'], HugeiconsProps['icon']]> = {
  global: [EarthIcon, EarthSolidIcon],
  local: [Location01Icon, Location01SolidIcon],
  network: [StarIcon, StarSolidIcon],
  search: [Search02Icon, Search02SolidIcon],
};

export function getFeedListHref(feedType: FeedType, fromFeedType?: FeedType | null): string {
  if (feedType === 'search') {
    const fromParam = fromFeedType && fromFeedType !== 'search' ? `?from=${fromFeedType}` : '';
    return `/feeds/search${fromParam}`;
  }

  return `/feeds/${feedType}`;
}

export function getFeedTypeFromPathname(pathname?: string | null): FeedType | null {
  if (!pathname?.startsWith('/feeds')) {
    return null;
  }

  const matchedType = feedTypes.find((feedType) => pathname.startsWith(`/feeds/${feedType}`));
  return matchedType ?? null;
}

export function getFeedListItems(t: TFunction): IFeedListItem[] {
  return feedTypes.map((feedType, index) => {
    const [icon, solidIcon] = feedIcons[feedType];

    return {
      value: feedType,
      label: t(`feeds.${feedType}`),
      icon,
      solidIcon,
      href: getFeedListHref(feedType),
      separatorBefore: feedType === 'search',
      sectionTitleBefore: index === 0 ? t('navigation.feeds') : undefined,
    };
  });
}
